import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const ServiceTypesPage = lazy(() => import('@pages/serviceTypes/ServiceTypesPage'));

// Route Component
const ServiceTypeTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('service-types-page-title')}>
        <ServiceTypesPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  ServiceTypeTablePage,
};
